import style from "./style.module.sass"
import { useStores } from "../../../../hooks";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

const Header = () => {
    const {i18n} = useTranslation(["general", "menu"]);

    const {catalogStore} = useStores();
    const headerPhotoUrl = catalogStore.aliasBinding.data.photosUrls[0];
    const hasHeaderPhoto = !!headerPhotoUrl;

    return <div className={[style.header, !hasHeaderPhoto && style.headerWithoutImage].filter(Boolean).join(" ")}>
        {hasHeaderPhoto && <div className={style.backgroundImage}>
            <img src={headerPhotoUrl} alt=""/>
        </div>}
        <div className={style.nameAndDescription}>
            <p className={style.title}>{catalogStore.aliasBinding.data.title[i18n.language]}</p>
            <p className={style.description}
               dangerouslySetInnerHTML={{__html: catalogStore.aliasBinding.data.description[i18n.language]}}/>
        </div>

    </div>
};

export default observer(Header);
